import Vue from 'vue';

// Definitions
export default [
    // Tasks
    {
        pathId: 'a',
        component: 'tasks',
        title: 'Tasks',
        icon: 'fa-tasks',
        size: 'sm', //sm, md, lg, xl
        reload: true,
        loading: true
    },
    {
        pathId: 'au',
        component: 'user-tasks',
        title: 'Tasks',
        icon: 'fa-tasks',
        size: 'sm', //sm, md, lg, xl
        props: ['assigneeId'],
        reload: true,
        loading: true
    },
    {
        pathId: 'ad',
        component: 'task-details',
        title: 'Task Details',
        icon: 'fa-tasks',
        size: 'sm', //sm, md, lg, xl
        props: ['type', 'assignee'],
        reload: true,
        loading: true
    },
    {
        pathId: 'tkn',
        component: 'new-task',
        title: 'New Task',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['entityType', 'entityId']
    },
    {
        pathId: 'tke',
        component: 'edit-task',
        title: 'Edit Task',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['taskId'],
        loading: true
    },
    {
        pathId: 'enn',
        component: 'new-entity-note',
        title: 'New Note',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['entityType', 'entityId']
    },
    {
        pathId: 'ene',
        component: 'edit-entity-note',
        title: 'Edit Note',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['noteId'],
        loading: true
    },
    // Contacts
    {
        pathId: 'cts',
        component: 'contacts',
        title: 'Contacts',
        icon: 'fa-address-book',
        size: 'md', //sm, md, lg, xl
        reload: true,
        loading: true
    },
    {
        pathId: 'ctsq',
        component: 'search-contacts',
        title: 'Contact Search',
        icon: 'fa-search',
        size: 'md', //sm, md, lg, xl
        props: ['query'],
        reload: true,
        loading: true
    },
    {
        pathId: 'ctt',
        component: 'contact-type',
        title: 'Contact Type',
        icon: 'fa-address-book',
        size: 'md', //sm, md, lg, xl
        props: ['type'],
        reload: true,
        loading: true
    },
    {
        pathId: 'ctc',
        component: 'contact-company',
        title: 'Company',
        icon: 'fa-building',
        size: 'md', //sm, md, lg, xl
        props: ['type', 'companyKey'],
        reload: true,
        loading: true
    },
    {
        pathId: 'ct',
        component: 'contact',
        title: 'Contact',
        icon: 'fa-address-book',
        size: 'md', //sm, md, lg, xl
        props: ['contactId'],
        reload: true,
        loading: true
    },
    {
        pathId: 'ctn',
        component: 'new-contact',
        title: 'New Contact',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['entityType', 'entityId', 'role']
    },
    // Same component as new-contact, addressed by where in the directory it
    // was opened from. A separate definition because card props are
    // positional in the path: 'ctn,hotel' would read as entityType=hotel.
    {
        pathId: 'ctnd',
        component: 'new-directory-contact',
        title: 'New Contact',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['type', 'companyKey']
    },
    {
        pathId: 'cte',
        component: 'edit-contact',
        title: 'Edit Contact',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['contactId'],
        loading: true
    },
    {
        pathId: 'ctp',
        component: 'pick-contact',
        title: 'Attach Contact',
        icon: 'fa-search',
        size: 'md', //sm, md, lg, xl
        props: ['entityType', 'entityId', 'role']
    },
    {
        pathId: 'ctl',
        component: 'edit-entity-contact',
        title: 'Edit Attachment',
        icon: 'fa-pencil',
        size: 'sm', //sm, md, lg, xl
        props: ['linkId'],
        loading: true
    },
    // Trips
    {
        pathId: 'ts',
        component: 'trips',
        title: 'Trips',
        icon: 'fa-plane',
        size: 'md', //sm, md, lg, xl
        loading: true
    },
    {
        pathId: 'tvs',
        component: 'archived-trips',
        title: 'Archived Trips',
        icon: 'fa-plane-arrival',
        size: 'md', //sm, md, lg, xl
        loading: true
    },
    {
        pathId: 't',
        component: 'trip',
        title: 'Trip',
        icon: 'fa-tennis-ball',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'tn',
        component: 'new-trip',
        title: 'New Trip',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
    },
    {
        pathId: 'te',
        component: 'edit-trip',
        title: 'Edit Trip',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'tdup',
        component: 'duplicate-trip',
        title: 'Duplicate Trip',
        icon: 'fa-copy',
        size: 'md', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'tdupds',
        component: 'duplicate-trip-days',
        title: 'Duplicate Itinerary',
        icon: 'fa-copy',
        size: 'md', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'tr',
        component: 'trip-reports',
        title: 'Trip Reports',
        icon: 'fa-clipboard-list-check',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'trr',
        component: 'trip-report-rooming',
        title: 'Rooming List',
        icon: 'fa-bed',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'trf',
        component: 'trip-report-flights',
        title: 'Participant Flights',
        icon: 'fa-plane',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'trs',
        component: 'trip-report-shirts',
        title: 'Shirt/Jacket Sizes',
        icon: 'fa-tshirt',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'tds',
        component: 'days',
        title: 'Trip Itinerary',
        icon: 'fa-calendar-alt',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'td',
        component: 'day',
        title: 'Day',
        icon: 'fa-calendar-day',
        size: 'sm', //sm, md, lg, xl
        props: ['dayId'],
        loading: true
    },
    {
        pathId: 'tdn',
        component: 'new-day',
        title: 'New Day',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['tripId']
    },
    {
        pathId: 'tde',
        component: 'edit-day',
        title: 'Edit Day',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['tripId', 'dayId']
    },
    {
        pathId: 'tden',
        component: 'new-event',
        title: 'New Event',
        icon: 'fa-plus',
        size: 'lg', //sm, md, lg, xl
        props: ['tripId', 'dayId'],
        loading: true
    },
    {
        pathId: 'tdee',
        component: 'edit-event',
        title: 'Edit Event',
        icon: 'fa-pencil',
        size: 'lg', //sm, md, lg, xl
        props: ['tripId', 'dayId', 'eventId'],
        loading: true
    },
    {
        pathId: 'tdedn',
        component: 'new-event-document',
        title: 'New Event Document',
        icon: 'fa-plus',
        size: 'lg', //sm, md, lg, xl
        props: ['tripId', 'dayId', 'eventId', 'registrationId', 'type']
    },
    {
        pathId: 'tdede',
        component: 'edit-event-document',
        title: 'Edit Event Document',
        icon: 'fa-pencil',
        size: 'lg', //sm, md, lg, xl
        props: ['tripId', 'dayId', 'eventId', 'docId', 'registrationId', 'type'],
        loading: true
    },
    {
        pathId: 'tdpn',
        component: 'new-day-photo',
        title: 'New Day Photo',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['tripId', 'dayId']
    },
    {
        pathId: 'tdpe',
        component: 'edit-day-photo',
        title: 'Edit Day Photo',
        icon: 'fa-pencil',
        size: 'sm', //sm, md, lg, xl
        props: ['photoId', 'dayId'],
        loading: true
    },
    {
        pathId: 'tas',
        component: 'trip-addons',
        title: 'Trip Add-Ons',
        icon: 'fa-layer-plus',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'tasl',
        component: 'addons-list',
        title: 'Trip Add-Ons',
        icon: 'fa-layer-plus',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId', 'type'],
        loading: true
    },
    {
        pathId: 'ta',
        component: 'trip-addon',
        title: 'Trip Add-On',
        icon: 'fa-layer-plus',
        size: 'sm', //sm, md, lg, xl
        props: ['addonId'],
        loading: true
    },
    {
        pathId: 'taps',
        component: 'addon-participants',
        title: 'Add-On Participants',
        icon: 'fa-street-view',
        size: 'sm', //sm, md, lg, xl
        props: ['addonId'],
        loading: true
    },
    {
        pathId: 'tan',
        component: 'new-trip-addon',
        title: 'New Trip Add-On',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl,
        props: ['tripId']
    },
    {
        pathId: 'tae',
        component: 'edit-trip-addon',
        title: 'Edit Trip Add-On',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['addonId'],
        loading: true
    },
    {
        pathId: 'ths',
        component: 'trip-hotels',
        title: 'Trip Hotels',
        icon: 'fa-hotel',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'thn',
        component: 'new-trip-hotel',
        title: 'New Trip Hotel',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['tripId']
    },
    {
        pathId: 'th',
        component: 'trip-hotel',
        title: 'Trip Hotel',
        icon: 'fa-hotel',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId', 'hotelId'],
        loading: true
    },
    {
        pathId: 'the',
        component: 'edit-trip-hotel',
        title: 'Edit Trip Hotel',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['tripId', 'hotelId'],
        loading: true
    },
    {
        pathId: 'tqs',
        component: 'questions',
        title: 'Registration Questions',
        icon: 'fa-clipboard-list-check',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'thrn',
        component: 'new-room-type',
        title: 'New Room Type',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['tripId', 'hotelId']
    },
    {
        pathId: 'thre',
        component: 'edit-room-type',
        title: 'Edit Room Type',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['tripId', 'hotelId', 'roomId'],
        loading: true
    },
    {
        pathId: 'tq',
        component: 'question',
        title: 'Question',
        icon: 'fa-clipboard-list-check',
        size: 'sm', //sm, md, lg, xl
        props: ['questionId'],
        loading: true
    },
    {
        pathId: 'tqn',
        component: 'new-question',
        title: 'New Question',
        icon: 'fa-plus',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId'],
    },
    {
        pathId: 'tqe',
        component: 'edit-question',
        title: 'Edit Question',
        icon: 'fa-pencil',
        size: 'sm', //sm, md, lg, xl
        props: ['questionId'],
        loading: true
    },
    {
        pathId: 'tqan',
        component: 'new-answer',
        title: 'New Answer',
        icon: 'fa-plus',
        size: 'sm', //sm, md, lg, xl
        props: ['questionId'],
    },
    {
        pathId: 'tqae',
        component: 'edit-answer',
        title: 'Edit Answer',
        icon: 'fa-pencil',
        size: 'sm', //sm, md, lg, xl
        props: ['questionId', 'answerId'],
        loading: true
    },
    {
        pathId: 'tqrs',
        component: 'question-responses',
        title: 'Question Responses',
        icon: 'fa-poll-people',
        size: 'sm', //sm, md, lg, xl
        props: ['questionId'],
        loading: true
    },
    {
        pathId: 'tps',
        component: 'trip-photos',
        title: 'Trip Photos',
        icon: 'fa-images',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'tpe',
        component: 'edit-trip-photo',
        title: 'Edit Trip Photo',
        icon: 'fa-pencil',
        size: 'sm', //sm, md, lg, xl
        props: ['photoId'],
        loading: true
    },
    {
        pathId: 'tpn',
        component: 'new-trip-photo',
        title: 'New Trip Photo',
        icon: 'fa-plus',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId']
    },
    {
        pathId: 'to',
        component: 'reg-overview',
        title: 'Registration Overview',
        icon: 'fa-users',
        size: 'lg', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'tfs',
        component: 'trip-flights',
        title: 'Participant Flights',
        icon: 'fa-plane',
        size: 'md', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'tnn',
        component: 'new-trip-note',
        title: 'New Trip Note',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['tripId']
    },
    {
        pathId: 'tne',
        component: 'edit-trip-note',
        title: 'Edit Trip Note',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['tripId', 'noteId'],
        loading: true
    },
    {
        pathId: 'tdocs',
        component: 'trip-documents',
        title: 'Trip Documents',
        icon: 'fa-file-alt',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'tdocn',
        component: 'new-trip-document',
        title: 'New Trip Document',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['tripId']
    },
    {
        pathId: 'tdoce',
        component: 'edit-trip-document',
        title: 'Edit Trip Document',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['tripId', 'docId'],
        loading: true
    },
    {
        pathId: 'tao',
        component: 'trip-app',
        title: 'Navigator Options',
        icon: 'fa-compass',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId']
    },
    {
        pathId: 'taoe',
        component: 'trip-app-editor',
        title: 'Navigator Options',
        icon: 'fa-pencil',
        size: 'lg', //sm, md, lg, xl
        props: ['tripId', 'type']
    },
    // #Social tab (Navigator mini social network)
    {
        pathId: 'xp',
        component: 'trip-experience',
        title: '#Social',
        icon: 'fa-hashtag',
        size: 'sm', //sm, md, lg, xl
        props: ['tripId']
    },
    {
        pathId: 'xpa',
        component: 'trip-announcements',
        title: 'Announcements',
        icon: 'fa-bullhorn',
        size: 'md', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'xpae',
        component: 'edit-announcement',
        title: 'Announcement',
        icon: 'fa-bullhorn',
        size: 'md', //sm, md, lg, xl
        props: ['tripId', 'postId']
    },
    {
        pathId: 'xpr',
        component: 'announcement-results',
        title: 'Poll Results',
        icon: 'fa-chart-bar',
        size: 'md', //sm, md, lg, xl
        props: ['tripId', 'postId'],
        loading: true
    },
    {
        pathId: 'xpw',
        component: 'trip-wall',
        title: 'Trip Wall',
        icon: 'fa-images',
        size: 'md', //sm, md, lg, xl
        props: ['tripId'],
        loading: true
    },
    {
        pathId: 'xpwp',
        component: 'wall-post',
        title: 'Wall Post',
        icon: 'fa-images',
        size: 'md', //sm, md, lg, xl
        props: ['tripId', 'postId'],
        loading: true
    },
    {
        pathId: 'xpwn',
        component: 'new-wall-post',
        title: 'New Wall Post',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['tripId']
    },
    // Registrations
    {
        pathId: 'rl',
        component: 'registrations',
        title: 'Registrations',
        icon: 'fa-suitcase-rolling',
        size: 'sm', //sm, md, lg, xl
        loading: true,
        reload: true,
        props: ['tripId']
    },
    {
        pathId: 'r',
        component: 'registration',
        title: 'Registration',
        icon: 'fa-suitcase',
        size: 'sm', //sm, md, lg, xl
        loading: true,
        props: ['registrationId']
    },
    {
        pathId: 'rn',
        component: 'new-registration',
        title: 'New Registration',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
    },
    {
        pathId: 'r-e',
        component: 'edit-registration',
        title: 'Edit Registration',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['registrationId']
    },
    {
        pathId: 'ri',
        component: 'itinerary',
        title: 'Registration Itinerary',
        icon: 'fa-calendar-alt',
        size: 'sm', //sm, md, lg, xl
        loading: true,
        props: ['tripId', 'registrationId']
    },
    {
        pathId: 'ritm',
        component: 'itemized',
        title: 'Itemized Registration',
        icon: 'fa-file-invoice',
        size: 'xl', //sm, md, lg, xl
        loading: true,
        props: ['regId']
    },
    {
        pathId: 'rrd',
        component: 'reg-days',
        title: 'Registration Days',
        icon: 'fa-calendar-check',
        size: 'sm', //sm, md, lg, xl
        loading: true,
        props: ['tripId', 'registrationId']
    },
    {
        pathId: 're',
        component: 'events',
        title: 'Events',
        icon: 'fa-calendar-alt',
        size: 'sm', //sm, md, lg, xl
        loading: true,
        props: ['tripId', 'registrationId', 'dayId']
    },
    {
        pathId: 'ren',
        component: 'new-custom-event',
        title: 'New Custom Event',
        icon: 'fa-plus',
        size: 'lg', //sm, md, lg, xl
        props: ['registrationId', 'dayId'],
        loading: true
    },
    {
        pathId: 'ree',
        component: 'edit-custom-event',
        title: 'Edit Custom Event',
        icon: 'fa-pencil',
        size: 'lg', //sm, md, lg, xl
        props: ['registrationId', 'dayId', 'eventId'],
        loading: true
    },
    {
        pathId: 'rec',
        component: 'copy-event',
        title: 'Copy Custom Event',
        icon: 'fa-copy',
        size: 'lg', //sm, md, lg, xl
        props: ['registrationId', 'dayId', 'eventId'],
        loading: true
    },
    {
        pathId: 'rfs',
        component: 'flights',
        title: 'Flights',
        icon: 'fa-plane',
        size: 'md', //sm, md, lg, xl
        props: ['registrationId'],
        loading: true
    },
    {
        pathId: 'rfn',
        component: 'new-flight',
        title: 'New Flight',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['registrationId']
    },
    {
        pathId: 'rfi',
        component: 'import-flight',
        title: 'Import SABRE',
        icon: 'fa-file-import',
        size: 'md', //sm, md, lg, xl
        props: ['registrationId'],
        loading: true
    },
    {
        pathId: 'rhs',
        component: 'reg-hotels',
        title: 'Hotels',
        icon: 'fa-hotel',
        size: 'sm', //sm, md, lg, xl
        props: ['registrationId'],
        loading: true
    },
    {
        pathId: 'rhn',
        component: 'new-reg-hotel',
        title: 'New Hotel',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['registrationId'],
        loading: true
    },
    {
        pathId: 'rhe',
        component: 'edit-reg-hotel',
        title: 'Edit Hotel',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['registrationId', 'hotelId'],
        loading: true
    },
    {
        pathId: 'rfe',
        component: 'edit-flight',
        title: 'Edit Flight',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['registrationId', 'flightId'],
        loading: true
    },
    {
        pathId: 'rfc',
        component: 'copy-flight',
        title: 'Copy Flight',
        icon: 'fa-copy',
        size: 'md', //sm, md, lg, xl
        props: ['registrationId', 'flightId'],
        loading: true
    },
    {
        pathId: 'roen',
        component: 'new-override-event',
        title: 'Customize Event',
        icon: 'fa-cog',
        size: 'md', //sm, md, lg, xl
        props: ['tripId', 'registrationId', 'dayId', 'eventId']
    },
    {
        pathId: 'roee',
        component: 'edit-override-event',
        title: 'Customize Event',
        icon: 'fa-cog',
        size: 'md', //sm, md, lg, xl
        props: ['registrationId', 'dayId', 'eventId'],
        loading: true
    },
    {
        pathId: 'ras',
        component: 'addons',
        title: 'Add-Ons',
        icon: 'fa-layer-plus',
        size: 'sm', //sm, md, lg, xl
        loading: true,
        props: ['registrationId']
    },
    {
        pathId: 'ran',
        component: 'new-addon',
        title: 'New Add-on',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['registrationId', 'tripId']
    },
    {
        pathId: 'rae',
        component: 'edit-addon',
        title: 'Edit Add-on',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['registrationId', 'addonId']
    },
    {
        pathId: 'rqs',
        component: 'responses',
        title: 'Question Responses',
        icon: 'fa-clipboard-list-check',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['registrationId']
    }, {
        pathId: 'rqn',
        component: 'new-response',
        title: 'New Response',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['registrationId', 'tripId']
    }, {
        pathId: 'rqe',
        component: 'edit-response',
        title: 'Edit Response',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['registrationId', 'responseId']
    },
    {
        pathId: 'rnn',
        component: 'new-reg-note',
        title: 'New Registration Note',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['registrationId']
    },
    {
        pathId: 'rne',
        component: 'edit-reg-note',
        title: 'Edit Registration Note',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['registrationId', 'noteId'],
        loading: true
    },
    {
        pathId: 'rds',
        component: 'reg-documents',
        title: 'Registration Documents',
        icon: 'fa-id-card',
        size: 'sm', //sm, md, lg, xl
        props: ['registrationId'],
        loading: true
    },
    {
        pathId: 'rdn',
        component: 'new-reg-document',
        title: 'New Registration Document',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['registrationId']
    },
    {
        pathId: 'rde',
        component: 'edit-reg-document',
        title: 'Edit Registration Document',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['registrationId', 'docId'],
        loading: true
    },
    // Customers
    {
        pathId: 'cs',
        component: 'customers',
        title: 'Customers',
        icon: 'fa-users',
        size: 'sm', //sm, md, lg, xl
        reload: true
    },
    {
        pathId: 'csq',
        component: 'search-customers',
        title: 'Search Customers',
        icon: 'fa-users',
        size: 'sm', //sm, md, lg, xl
        props: ['query']
    },
    {
        pathId: 'c',
        component: 'customer',
        title: 'Customer',
        icon: 'fa-user',
        size: 'sm', //sm, md, lg, xl
        loading: true,
        props: ['userId']
    },
    {
        pathId: 'cn',
        component: 'new-customer',
        title: 'New Customer',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
    },
    {
        pathId: 'ce',
        component: 'edit-customer',
        title: 'Edit Customer',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['userId']
    },
    {
        pathId: 'cnn',
        component: 'new-customer-note',
        title: 'New Customer Note',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['userId']
    },
    {
        pathId: 'cne',
        component: 'edit-customer-note',
        title: 'Edit Customer Note',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['userId', 'noteId'],
        loading: true
    },
    {
        pathId: 'cds',
        component: 'customer-documents',
        title: 'Documents',
        icon: 'fa-id-card',
        size: 'sm', //sm, md, lg, xl
        props: ['userId'],
        loading: true
    },
    {
        pathId: 'cdn',
        component: 'new-document',
        title: 'New Document',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['userId']
    },
    {
        pathId: 'cde',
        component: 'edit-document',
        title: 'Edit Document',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        props: ['userId', 'docId'],
        loading: true
    },
    {
        pathId: 'crs',
        component: 'customer-registrations',
        title: 'Customer Registrations',
        icon: 'fa-suitcase',
        size: 'sm', //sm, md, lg, xl
        props: ['userId'],
        loading: true
    },
    {
        pathId: 'csh',
        component: 'customer-share',
        title: 'Share Links',
        icon: 'fa-share-square',
        size: 'md', //sm, md, lg, xl
        props: ['userId'],
        loading: true
    },
    {
        pathId: 'cph',
        component: 'change-customer-photo',
        title: 'Change Photo',
        icon: 'fa-camera',
        size: 'md', //sm, md, lg, xl
        props: ['userId']
    },
    // Payment Plans
    {
        pathId: 'pp',
        component: 'payment-plan',
        title: 'Payment Plan',
        icon: 'fa-credit-card-front',
        size: 'sm',
        loading: true,
        props: ['planId', 'regId']

    },
    {
        pathId: 'ppe',
        component: 'edit-payment-plan',
        title: 'Edit Payment Plan',
        icon: 'fa-pencil',
        size: 'md',
        loading: true,
        props: ['planId', 'regId']
    },
    {
        pathId: 'ppmp',
        component: 'make-payment',
        title: 'Make Payment',
        icon: 'fa-credit-card',
        size: 'md',
        loading: true,
        props: ['planId', 'regId']
    },
    {
        pathId: 'pppin',
        component: 'new-plan-item',
        title: 'New Payment Plan Item',
        icon: 'fa-plus',
        size: 'md',
        props: ['planId', 'regId']
    },
    {
        pathId: 'pppie',
        component: 'edit-plan-item',
        title: 'Edit Payment Plan Item',
        icon: 'fa-pencil',
        size: 'md',
        props: ['planId', 'itemId']
    },
    {
        pathId: 'pppmn',
        component: 'new-payment-method',
        title: 'New Payment Method',
        icon: 'fa-plus',
        size: 'md',
        props: ['planId', 'regId'],
        loading: true
    },
    {
        pathId: 'pppme',
        component: 'edit-payment-method',
        title: 'Edit Payment Method',
        icon: 'fa-pencil',
        size: 'md',
        props: ['planId', 'methodId']

    },
    {
        pathId: 'pptn',
        component: 'new-transaction',
        title: 'New Transaction',
        icon: 'fa-plus',
        size: 'md',
        props: ['regId', 'planId']
    },
    {
        pathId: 'ppte',
        component: 'edit-transaction',
        title: 'Edit Transaction',
        icon: 'fa-pencil',
        size: 'md',
        props: ['regId', 'planId', 'transactionId']
    },
    // Communication
    {
        pathId: 'cm',
        component: 'communication',
        title: 'Communication',
        icon: 'fa-comments-alt',
        size: 'sm', //sm, md, lg, xl
    },
    {
        pathId: 'mk',
        component: 'marketing',
        title: 'Marketing',
        icon: 'fa-search-dollar',
        size: 'sm', //sm, md, lg, xl
    },
    // Leads Database
    {
        pathId: 'lds',
        component: 'leads',
        title: 'Leads Database',
        icon: 'fa-address-card',
        size: 'sm', //sm, md, lg, xl
        reload: true
    },
    {
        pathId: 'ldq',
        component: 'search-leads',
        title: 'Search Leads',
        icon: 'fa-address-card',
        size: 'sm', //sm, md, lg, xl
        props: ['query']
    },
    {
        pathId: 'ld',
        component: 'lead',
        title: 'Lead',
        icon: 'fa-address-card',
        size: 'sm', //sm, md, lg, xl
        loading: true,
        props: ['leadId']
    },
    {
        pathId: 'rp',
        component: 'reports',
        title: 'Reports',
        icon: 'fa-clipboard-list-check',
        size: 'sm', //sm, md, lg, xl
    },
    {
        pathId: 's',
        component: 'settings',
        title: 'Settings',
        icon: 'fa-cogs',
        size: 'sm', //sm, md, lg, xl
    },
    {
        pathId: 'sed',
        component: 'event-descriptions',
        title: 'Event Descriptions',
        icon: 'fa-align-left',
        size: 'sm', //sm, md, lg, xl
        loading: true,
        reload: true
    },
    {
        pathId: 'sedn',
        component: 'new-event-description',
        title: 'New Event Description',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
    },
    {
        pathId: 'sede',
        component: 'edit-event-description',
        title: 'Edit Event Description',
        icon: 'fa-pencil',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['descriptionId']
    },
    {
        pathId: 'us',
        component: 'user-settings',
        title: 'User Settings',
        icon: 'fa-user-cog',
        size: 'sm', //sm, md, lg, xl
    },
    // Billing
    {
        pathId: 'b',
        component: 'billing',
        title: 'Billing',
        icon: 'fa-credit-card',
        size: 'sm'
    },
    {
        pathId: 'bd',
        component: 'billing-due',
        title: 'Plan Items Past Due',
        icon: 'fa-history',
        size: 'sm',
        loading: true,
        reload: true
    },
];

// Components

Vue.component('tasks', () => import('@/cards/tasks/Tasks'));
Vue.component('user-tasks', () => import('@/cards/tasks/UserTasks'));
Vue.component('task-details', () => import('@/cards/tasks/Details'));
Vue.component('new-task', () => import('@/cards/tasks/NewTask'));
Vue.component('edit-task', () => import('@/cards/tasks/EditTask'));
Vue.component('new-entity-note', () => import('@/cards/notes/NewEntityNote'));
Vue.component('edit-entity-note', () => import('@/cards/notes/EditEntityNote'));
Vue.component('contacts', () => import('@/cards/contacts/Contacts'));
Vue.component('search-contacts', () => import('@/cards/contacts/SearchContacts'));
Vue.component('contact-type', () => import('@/cards/contacts/ContactType'));
Vue.component('contact-company', () => import('@/cards/contacts/ContactCompany'));
Vue.component('contact', () => import('@/cards/contacts/Contact'));
Vue.component('new-contact', () => import('@/cards/contacts/NewContact'));
Vue.component('new-directory-contact', () => import('@/cards/contacts/NewContact'));
Vue.component('edit-contact', () => import('@/cards/contacts/EditContact'));
Vue.component('pick-contact', () => import('@/cards/contacts/PickContact'));
Vue.component('edit-entity-contact', () => import('@/cards/contacts/EditEntityContact'));

Vue.component('trips', () => import('@/cards/trips/Trips'));
Vue.component('archived-trips', () => import('@/cards/trips/ArchivedTrips'));
Vue.component('trip', () => import('@/cards/trips/Trip'));
Vue.component('new-trip', () => import('@/cards/trips/NewTrip'));
Vue.component('edit-trip', () => import('@/cards/trips/EditTrip'));
Vue.component('duplicate-trip', () => import('@/cards/trips/DuplicateTrip'));
Vue.component('duplicate-trip-days', () => import('@/cards/trips/DuplicateDays'));
Vue.component('trip-reports', () => import('@/cards/trips/reports/Reports'));
Vue.component('trip-report-rooming', () => import('@/cards/trips/reports/RoomingList'));
Vue.component('trip-report-flights', () => import('@/cards/trips/reports/FlightsReport'));
Vue.component('trip-report-shirts', () => import('@/cards/trips/reports/ShirtsReport'));
Vue.component('trip-addons', () => import('@/cards/trips/addons/TripAddOns'));
Vue.component('addons-list', () => import('@/cards/trips/addons/AddOnsList'));
Vue.component('trip-addon', () => import('@/cards/trips/addons/Addon'));
Vue.component('addon-participants', () => import('@/cards/trips/addons/AddonParticipants'));
Vue.component('new-trip-addon', () => import('@/cards/trips/addons/NewAddon'));
Vue.component('edit-trip-addon', () => import('@/cards/trips/addons/EditAddon'));
Vue.component('day', () => import('@/cards/trips/Day'));
Vue.component('new-day', () => import('@/cards/trips/NewDay'));
Vue.component('edit-day', () => import('@/cards/trips/EditDay'));
Vue.component('new-event', () => import('@/cards/trips/NewEvent'));
Vue.component('edit-event', () => import('@/cards/trips/EditEvent'));
Vue.component('new-event-document', () => import('@/cards/trips/NewEventDocument'));
Vue.component('edit-event-document', () => import('@/cards/trips/EditEventDocument'));
Vue.component('new-day-photo', () => import('@/cards/trips/NewDayPhoto'));
Vue.component('edit-day-photo', () => import('@/cards/trips/EditDayPhoto'));
Vue.component('days', () => import('@/cards/trips/Days'));
Vue.component('trip-hotels', () => import('@/cards/trips/hotels/Hotels'));
Vue.component('new-trip-hotel', () => import('@/cards/trips/hotels/NewHotel'));
Vue.component('trip-hotel', () => import('@/cards/trips/hotels/Hotel'));
Vue.component('edit-trip-hotel', () => import('@/cards/trips/hotels/EditHotel'));
Vue.component('new-room-type', () => import('@/cards/trips/NewRoomType'));
Vue.component('edit-room-type', () => import('@/cards/trips/EditRoomType'));
Vue.component('questions', () => import('@/cards/trips/Questions'));
Vue.component('question', () => import('@/cards/trips/Question'));
Vue.component('new-question', () => import('@/cards/trips/NewQuestion'));
Vue.component('edit-question', () => import('@/cards/trips/EditQuestion'));
Vue.component('new-answer', () => import('@/cards/trips/NewAnswer'));
Vue.component('edit-answer', () => import('@/cards/trips/EditAnswer'));
Vue.component('question-responses', () => import('@/cards/trips/Responses'));
Vue.component('trip-photos', () => import('@/cards/trips/Photos'));
Vue.component('edit-trip-photo', () => import('@/cards/trips/EditTripPhoto'));
Vue.component('new-trip-photo', () => import('@/cards/trips/NewTripPhoto'));
Vue.component('reg-overview', () => import('@/cards/trips/RegistrationOverview'));
Vue.component('trip-flights', () => import('@/cards/trips/TripFlights'));
Vue.component('new-trip-note', () => import('@/cards/trips/NewNote'));
Vue.component('edit-trip-note', () => import('@/cards/trips/EditNote'));
Vue.component('trip-documents', () => import('@/cards/trips/Documents'));
Vue.component('new-trip-document', () => import('@/cards/trips/NewDocument'));
Vue.component('edit-trip-document', () => import('@/cards/trips/EditDocument'));
Vue.component('trip-app', () => import('@/cards/trips/app/TripApp'));
Vue.component('trip-app-editor', () => import('@/cards/trips/app/AppEditor'));
Vue.component('trip-experience', () => import('@/cards/trips/experience/TripExperience'));
Vue.component('trip-announcements', () => import('@/cards/trips/experience/TripAnnouncements'));
Vue.component('edit-announcement', () => import('@/cards/trips/experience/EditAnnouncement'));
Vue.component('announcement-results', () => import('@/cards/trips/experience/AnnouncementResults'));
Vue.component('trip-wall', () => import('@/cards/trips/experience/TripWall'));
Vue.component('wall-post', () => import('@/cards/trips/experience/WallPost'));
Vue.component('new-wall-post', () => import('@/cards/trips/experience/NewWallPost'));

Vue.component('registrations', () => import('@/cards/registrations/Registrations'));
Vue.component('registration', () => import('@/cards/registrations/Registration'));
Vue.component('new-registration', () => import('@/cards/registrations/NewRegistration'));
Vue.component('edit-registration', () => import('@/cards/registrations/EditRegistration'));
Vue.component('itemized', () => import('@/cards/registrations/Itemized'));
Vue.component('itinerary', () => import('@/cards/registrations/Itinerary'));
Vue.component('events', () => import('@/cards/registrations/Events'));
Vue.component('reg-days', () => import('@/cards/registrations/RegistrationDays'));
Vue.component('new-custom-event', () => import('@/cards/registrations/NewEvent'));
Vue.component('edit-custom-event', () => import('@/cards/registrations/EditEvent'));
Vue.component('flights', () => import('@/cards/registrations/Flights'));
Vue.component('new-flight', () => import('@/cards/registrations/NewFlight'));
Vue.component('import-flight', () => import('@/cards/registrations/ImportFlight'));
Vue.component('edit-flight', () => import('@/cards/registrations/EditFlight'));
Vue.component('copy-flight', () => import('@/cards/registrations/CopyFlight'));
Vue.component('copy-event', () => import('@/cards/registrations/CopyEvent'));
Vue.component('reg-hotels', () => import('@/cards/registrations/Hotels'));
Vue.component('new-reg-hotel', () => import('@/cards/registrations/NewHotel'));
Vue.component('edit-reg-hotel', () => import('@/cards/registrations/EditHotel'));
Vue.component('new-override-event', () => import('@/cards/registrations/NewOverrideEvent'));
Vue.component('edit-override-event', () => import('@/cards/registrations/EditOverrideEvent'));
Vue.component('addons', () => import('@/cards/registrations/Addons'));
Vue.component('new-addon', () => import('@/cards/registrations/NewAddon'));
Vue.component('edit-addon', () => import('@/cards/registrations/EditAddon'));
Vue.component('responses', () => import('@/cards/registrations/Responses'));
Vue.component('new-response', () => import('@/cards/registrations/NewResponse'));
Vue.component('edit-response', () => import('@/cards/registrations/EditResponse'));
Vue.component('payment-plan', () => import('@/cards/plans/Plan'));
Vue.component('edit-payment-plan', () => import('@/cards/plans/EditPlan'));
Vue.component('make-payment', () => import('@/cards/plans/MakePayment'));
Vue.component('new-payment-method', () => import('@/cards/plans/NewMethod'));
Vue.component('edit-payment-method', () => import('@/cards/plans/EditMethod'));
Vue.component('new-plan-item', () => import('@/cards/plans/NewPlanItem'));
Vue.component('edit-plan-item', () => import('@/cards/plans/EditPlanItem'));
Vue.component('new-transaction', () => import('@/cards/plans/NewTransaction'));
Vue.component('edit-transaction', () => import('@/cards/plans/EditTransaction'));
Vue.component('new-reg-note', () => import('@/cards/registrations/NewNote'));
Vue.component('edit-reg-note', () => import('@/cards/registrations/EditNote'));
Vue.component('reg-documents', () => import('@/cards/registrations/Documents'));
Vue.component('new-reg-document', () => import('@/cards/registrations/NewDocument'));
Vue.component('edit-reg-document', () => import('@/cards/registrations/EditDocument'));

Vue.component('customers', () => import('@/cards/customers/Customers'));
Vue.component('search-customers', () => import('@/cards/customers/Search'));
Vue.component('customer', () => import('@/cards/customers/Customer'));
Vue.component('new-customer', () => import('@/cards/customers/NewCustomer'));
Vue.component('edit-customer', () => import('@/cards/customers/EditCustomer'));
Vue.component('new-customer-note', () => import('@/cards/customers/NewNote'));
Vue.component('edit-customer-note', () => import('@/cards/customers/EditNote'));
Vue.component('customer-documents', () => import('@/cards/customers/Documents'));
Vue.component('new-document', () => import('@/cards/customers/NewDocument'));
Vue.component('edit-document', () => import('@/cards/customers/EditDocument'));
Vue.component('customer-registrations', () => import('@/cards/customers/Registrations'));
Vue.component('customer-share', () => import('@/cards/customers/Share'));
Vue.component('change-customer-photo', () => import('@/cards/customers/ChangeCustomerPhoto'));

Vue.component('billing', () => import('@/cards/billing/Billing'));
Vue.component('billing-due', () => import('@/cards/billing/Due'));

Vue.component('communication', () => import('@/cards/communication/Communication'));
Vue.component('marketing', () => import('@/cards/marketing/Marketing'));
Vue.component('leads', () => import('@/cards/marketing/Leads'));
Vue.component('search-leads', () => import('@/cards/marketing/SearchLeads'));
Vue.component('lead', () => import('@/cards/marketing/Lead'));
Vue.component('reports', () => import('@/cards/reports/Reports'));
Vue.component('settings', () => import('@/cards/settings/Settings'));
Vue.component('event-descriptions', () => import('@/cards/settings/EventDescriptions'));
Vue.component('new-event-description', () => import('@/cards/settings/NewEventDescription'));
Vue.component('edit-event-description', () => import('@/cards/settings/EditEventDescription'));
Vue.component('user-settings', () => import('@/cards/user_settings/UserSettings'));
